import { createStore } from 'redux';

const initState = {
  currentSceneID: '',
  currentLesson: '',
  location: '',
  activeSection: 0,
  conversationLength: 0,
  microphoneActive: false,
  activeButton: 1,
  currentButtonScore: null,
  recognitionText: '',
  recognising: false,
  audioBlobs: [],
  npcAudioBlobs: [],
  buttonOrder: 0,
  playNpcAudio: false,
  playButtonAudio: false,
  preteachActive: false,
  skipCount: 0,
  conversationData: {}
};

const storeReducer = (state = initState, action) => {
  if (action.type === 'startLesson') {
    return {
      ...state,
      currentSceneID: action.payload.sceneID,
      currentLesson: action.payload.lesson,
    };
  }

  //Reset lesson and scene so we don't end up with mismatch data
  if (action.type === 'resetCurrentLesson') {
    return {
      ...state,
      currentSceneID: '',
      currentLesson: '',
      conversationData: {},
      audioBlobs: [],
      npcAudioBlobs: [],
    };
  }

  if (action.type === 'setLesson') {
    return {
      ...state,
      currentLesson: action.payload.lesson,
    };
  }

  if (action.type === 'setCurrentScene') {
    return {
      ...state,
      currentSceneID: action.payload.sceneID,
    };
  }

  if (action.type === 'setLocation') {
    return {
      ...state,
      location: action.payload.location,
      microphoneActive: false,
      activeButton: 1,
    };
  }

  if (action.type === 'setConversationLength') {
    return {
      ...state,
      conversationLength: action.payload.length,
      microphoneActive: false,
      activeButton: 1,
    };
  }

  if (action.type === 'updateActiveSection') {
    let updatedVal = state.activeSection + 1;

    if (updatedVal > state.conversationLength) {
      updatedVal = state.conversationLength;
    }

    return {
      ...state,
      activeSection: updatedVal,
      microphoneActive: false,
      activeButton: 1,
      playNpcAudio: true,
    };
  }

  if (action.type === 'setActiveSection') {
    return {
      ...state,
      activeSection: action.payload.section,
      microphoneActive: false,
      activeButton: 1,
    };
  }

  if (action.type === 'resetActiveSection') {
    return {
      ...state,
      activeSection: 0,
      playNpcAudio: false,
      microphoneActive: false,
      activeButton: 1,
      skipCount: 0,
      buttonOrder: 1,
    };
  }

  if (action.type === 'initMicrophone') {
    return {
      ...state,
      microphoneActive: true,
    };
  }

  if (action.type === 'deactivateMicrophone') {
    return {
      ...state,
      microphoneActive: false,
    };
  }

  if (action.type === 'startSpeechRecognition') {
    return {
      ...state,
      recognising: true,
      microphoneActive: false,
      recognitionText: '',
    };
  }

  if (action.type === 'stopSpeechRecognition') {
    return {
      ...state,
      recognising: false,
    };
  }

  if (action.type === 'setActiveButton') {
    return {
      ...state,
      activeButton: action.payload.activeButton,
    };
  }

  if (action.type === 'setCurrentButtonScore') {
    return {
      ...state,
      currentButtonScore: action.payload.score,
    };
  }

  if (action.type === 'setRecognitionText') {
    return {
      ...state,
      recognitionText: action.payload.text,
    };
  }

  if (action.type === 'resetConversationButton') {
    return {
      ...state,
      recognitionText: '',
      currentButtonScore: null,
      recognising: false,
      microphoneActive: false,
    };
  }

  if (action.type === 'retryAudio') {
    return {
      ...state,
      recognitionText: '',
      currentButtonScore: null,
      recognising: true,
      microphoneActive: false,
    };
  }

  if (action.type === 'buttonUntoggled') {
    let activeButtonHelper =
      state.activeButton - 1 < 0 ? 0 : state.activeButton - 1;
    return {
      ...state,
      recognitionText: '',
      currentButtonScore: null,
      activeButton: activeButtonHelper,
      recognising: false,
      microphoneActive: false,
    };
  }

  if (action.type === 'setAudioBlobs') {
    return {
      ...state,
      audioBlobs: action.payload.blobs,
    };
  }

  if (action.type === 'playButtonAudio') {
    return {
      ...state,
      buttonOrder: action.payload.buttonOrder,
      playButtonAudio: true,
    };
  }

  if (action.type === 'stopButtonAudio') {
    return {
      ...state,
      playButtonAudio: false,
    };
  }

  if (action.type === 'setNpcAudioBlobs') {
    return {
      ...state,
      npcAudioBlobs: action.payload.blobs,
    };
  }

  if (action.type === 'playNpcAudio') {
    return {
      ...state,
      playNpcAudio: true,
    };
  }

  if (action.type === 'stopNpcAudio') {
    return {
      ...state,
      playNpcAudio: false,
    };
  }

  if (action.type === 'activatePreteach') {
    return {
      ...state,
      preteachActive: true,
    };
  }

  if (action.type === 'deactivatePreteach') {
    return {
      ...state,
      preteachActive: false,
    };
  }
  
  if (action.type === 'setConversationData') {
    return {
      ...state,
      conversationData: action.payload.convData,
    };
  }

  return state;
};

const store = createStore(storeReducer);

export default store;
